import React from 'react';

const FeaturesCard = ({ logo, info }) => {
    return (
        <div className="col-md-4">
            <div className="features-box">
                <div>
                    <img src={info?.img?.url} className="img-fluid" alt="" />
                </div>
                <p className="m-0 pt-2">{info?.text}</p>
            </div>
        </div>
    );
};

export default FeaturesCard;